import React from 'react'
import userDetailsReducer from '../../state/user/get-user-details/reducer'
import combineReducers from '../../utils/combineReducers'
import updateUserReducer from '../../state/user/update-user/reducer'

import getUserDetails from '../../state/user/get-user-details/actions'
import {updateUserData} from '../../state/user/update-user/actions'

const UserContext = React.createContext(null)

function UserContextProvider(props) {
  const userState = {
    error: null,
    isLoading: false,
  }

  const [state, dispatch] = React.useReducer(
    combineReducers({details: userDetailsReducer, userDetail: updateUserReducer}),
    userState
  )

  const getDetails = React.useCallback(() => getUserDetails(dispatch), [])
  const updateUserDetails = React.useCallback(params => updateUserData(dispatch, params), [])

  React.useEffect(() => {
    getUserDetails(dispatch)
  }, [])

  const value = {
    getDetails,
    dispatch,
    updateUserDetails,
    ...state,
  }

  return <UserContext.Provider value={value}>{props.children}</UserContext.Provider>
}

const UserContextConsumer = UserContext.Consumer

export {UserContext, UserContextProvider, UserContextConsumer}
